import { useEffect, useRef, useState } from 'react';
import AppVersionEdit from './AppVersionEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../universal/columnshead';
import {  Select, Space, Tooltip } from 'antd';
import dayjs from 'dayjs';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../../utilsTsx/universal/getList';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const apiId = 'appVersion';
    const [appData, setAppData] = useState<any>();
    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [fethcData, setFethcData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setDefaultService(urlService);
            setFethcData(() => ref.current.fetchData);
        }
        fetchApi.GET(urlService,
            {
                apiId: 'app',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setAppData([{ id: 'allApp', name: '所有' }, ...res.data]);
                }
            })
    }, []);

    //表头
    const columnsHead = [
        {
            title: '应用',
            dataIndex: 'app',
            render: (val: any) => val?.name
        },
        {
            title: '版本',
            dataIndex: 'versionName',
        },
        {
            title: '更新说明',
            dataIndex: 'changelog',
            render: (val: any) => <Tooltip placement="topLeft" title={`${val.substring(0, 50)}......`}>{
                val ? (val.length >= 20 ? `${val.substring(0, 20)}......` : val) : ''
            }</Tooltip>
        },
        {
            title: '发布日期',
            dataIndex: 'releaseDate',
            render: (text: any) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: '排序',
            dataIndex: 'sorting'
        },
        {
            title: '默认',
            dataIndex: 'isDefault',
            render: (val: any) => val ? '是' : '否'
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '应用版本',
        apiId,
        columns,
        editOptions: {
            Editor: AppVersionEdit
        },
        sendPageData: {
            sendPageData: { appId: 'allApp' }
        }
    };

    return (
        <> <Space>
            <Select
                showSearch
                placeholder="应用"
                optionFilterProp="children"
                defaultValue={'allApp'}
                onChange={(e) => {
                    fethcData({
                        apiId,
                        sendPageData: { appId: e }
                    });
                }}
                style={{ width: 130 }}
                filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(appData)}
            </Select>
        </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
        </>
    )
}

export default WebComponent;
